class FormSelect extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)

    this.trigger = this.els?.trigger?.element
    this.selected = this.els?.selected?.element
    this.dropdown = this.els?.dropdown?.element
    this.buttons = this.els?.button?.elements
    this.radios = this.els?.radio?.elements

    this.orderIdField = this.externalEls?.['order-id-field']?.element
    this.orderIdInput = this.externalEls?.['order-id-input']?.element

    if (
      !this.trigger ||
      !this.selected ||
      !this.dropdown ||
      !this.buttons ||
      !this.radios
    ) {
      return
    }

    this.listeners.add(window, `click`, this.handleClick)
  }

  handleClick (event) {
    const closestTrigger = event.target.closest(this.els?.trigger?.selector)
    const closestButton = event.target.closest(this.els?.button?.selector)

    if (closestButton) {
      this.handleButtonClick(closestButton)
    } else if (closestTrigger) {
      this.handleTriggerClick(closestTrigger)
    } else {
      this.close()
    }
  }

  handleKeydown (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      const button = event.currentTarget
      this.handleButtonClick(button)
    }
  }

  handleButtonClick (targetButton) {
    this.radios.forEach(radio => {
      radio.checked = radio.dataset.index === targetButton.dataset.index
      radio.dispatchEvent(new Event('input', { bubbles: true }))

      if (radio.dataset.index === targetButton.dataset.index) {
        this.selected.innerText = radio.value
        this.selected.classList.add('frm-Select_TriggerText-selected')

        if (!this.orderIdField || !this.orderIdInput) return

        const requiresOrderId = radio.dataset.requiresOrderId === 'true'

        this.orderIdField.setAttribute(
          'aria-hidden',
          !requiresOrderId ? 'true' : 'false',
        )
        this.orderIdInput.disabled = !requiresOrderId

        if (!requiresOrderId) this.orderIdInput.value = ''
      }
    })

    this.buttons.forEach(button => {
      button.setAttribute(
        'aria-selected',
        button.dataset.index === targetButton.dataset.index,
      )
    })

    this.close(true)
  }

  handleTriggerClick (button) {
    if (button.getAttribute('aria-selected') === 'true') {
      this.close(true)
    } else {
      this.open()
    }
  }

  open () {
    this.trigger.setAttribute('aria-selected', 'true')
    this.dropdown.setAttribute('aria-hidden', 'false')
  }

  close (focusTrigger = false) {
    if (focusTrigger === true) this.trigger.focus()

    this.trigger.setAttribute('aria-selected', 'false')
    this.dropdown.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('form-select')) {
  customElements.define('form-select', FormSelect)
}
